export default function retry(fn, retriesLeft, interval) {
    if (retriesLeft === void 0) { retriesLeft = 5; }
    if (interval === void 0) { interval = 1000; }
    return new Promise(function (resolve, reject) {
        fn()
            .then(resolve)
            .catch(function (error) {
            setTimeout(function () {
                // When offline keep retrying
                if (!navigator.onLine) {
                    retry(fn, retriesLeft, Math.min(interval * 1.1, 10000)).then(resolve, reject);
                    return;
                }
                // All done, just fail as usual
                if (retriesLeft === 0) {
                    reject(error);
                    return;
                }
                // Retry
                retry(fn, retriesLeft - 1, interval * 1.1).then(resolve, reject);
            }, interval);
        });
    });
}
//# sourceMappingURL=chunkRetry.js.map